import React, {Component} from 'react';
import RedirectOnlyHome from "../common/RedirectOnlyHome";

class SuccessPreparedPage extends Component {
	render() {
		const { extradriver, additional_drivers } = this.props;
		return (<>
			<RedirectOnlyHome />
			<div className={'col text-center'} style={{padding: "20px 30px", marginBottom: "25px"}}>

				<h3 style={{color:"#d63545"}}>Your booking has been successfully submitted,<br/>soon you’ll be going with the Gecko!</h3>
				{
					!extradriver ? (
					<div>
						<br/><br/>
						Thank you for completing your reservation, it is now with our Go With The Gecko team, and they will be approving your booking shortly.
						<br/>
						Once it is approved, you will receive confirmation of your booking, including details of how to access your vehicle.
					</div>
					):null
				}
				{
					!extradriver && additional_drivers > 0 ? (
					<div>
						<br/>
						For your additional hirer, please forward the details of how to access the vehicle to them, so they can start the hire too.
					</div>
					):null
				}
				{
					extradriver && additional_drivers > 0 ?(
					<div>
						<br/><br/>
						Thank you for completing your part of the reservation, it is now with our Go With The Gecko team, and they will be approving your booking once the hirer has completed their part of the reservation process.  They will also be receiving the vehicle access details, which they’ll forward to you so that you can access the vehicle too.
					</div>
					):null
				}

				<div>
					<br/><br/>
					<strong>Have a nice day!</strong><br/>
					<em>Go With The Gecko Team</em>
				</div>
			</div>
		</>);
	}
}

export default SuccessPreparedPage;